import { useModals } from "web/hooks/modals"
import { Label } from "web/components/Form/Controls"

import { SearchInput } from "web/components"

function PortfolioSearchModal({ prompt, respond }) {
  async function handleSelect(result) {
    respond(result)
  }

  return (
    <div className="p-5">
      <Label label={prompt} />
      <div>
        <SearchInput
          scope="portfolio"
          onSelect={handleSelect}
          autoFocus={true}
        />
      </div>
    </div>
  )
}

export default function usePortfolioSearchModal() {
  const { showModal } = useModals()

  return async function ({ title, prompt }) {
    return await showModal({
      title: title,
      fullScreen: false,
      heightPixels: 400,
      widthPixels: 400,
      component: ({ respond }) => (
        <PortfolioSearchModal prompt={prompt} respond={respond} />
      ),
    })
  }
}
